// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'organization-location.page.title': 'Organization Locations',
    'organization-location.page.archive.title': 'Archived Locations',
    'organization-location.page.search_results': 'Search Results',
    'organization-location.page.create.title': 'Create New Location',
    'organization-location.page.search.title': 'Find Locations',
    'organization-location.page.edit.title': 'Edit Location',
    'organization-location.page.view.title': 'View Location',
    'organization-location.page.all': 'All',

    'organization-location.button.cancel': 'Cancel',
    'organization-location.button.select': 'Select',
    'organization-location.button.find': 'Find Locations',
    'organization-location.button.search': 'Apply',
    'organization-location.button.create': 'Save Location',
    'organization-location.button.new': 'New Location',
    'organization-location.button.save': 'Save Changes',
    'organization-location.button.archive': 'Archive',
    'organization-location.button.delete': 'Permanently Delete',
    'organization-location.button.edit': 'Edit',
    'organization-location.button.restore': 'Restore',
    'organization-location.button.reset': 'Reset',

    'organization-location.placeholder.search': 'Search locations',

    'organization-location.link.create_first_organization_location': 'Click here to create your first location',
    'organization-location.link.organization_locations': ' Return to Locations',
    'organization-location.link.archive': 'Archived Locations',
    'organization-location.link.retry': 'Click here to retry',

    'organization-location.checkbox.all': 'Check All',
    'organization-location.checkbox.actions_label': 'with selected',

    'organization-location.label.organization_location_name': 'Location Name',

    'organization-location.label.from__created_at': 'From created at',
    'organization-location.label.to__created_at': 'To created at',
    'organization-location.label.created_at': 'Created At',

    'organization-location.label.status': 'Status',

    'organization-location.sort.field_label': 'Field',
    'organization-location.sort.direction_label': 'Direction',
    'organization-location.sort.direction_ascending': 'Ascending',
    'organization-location.sort.direction_descending': 'Descending',

    'organization-location.modal.title.organization_location_archive': 'Archive Location',
    'organization-location.modal.title.organization_location_delete_permanently': 'Delete Location',
    'organization-location.modal.title.organization_location_restore': 'Restore Location',

    'organization-location.modal.message.organization_location_archive': 'Are you sure that you want to move this location to the archive? | Are you sure that you want to move these locations to the archive?',
    'organization-location.modal.message.organization_location_delete_permanently':
        'Are you sure that you want to permanently delete this location? This action cannot be undone. | Are you sure that you want to permanently delete these locations? This action cannot be undone.',
    'organization-location.modal.message.organization_location_restore': 'Are you sure that you want to restore this location? | Are you sure that you want to restore these locations?',

    'organization-location.success.message.organization_location_created': 'Your location has been created',
    'organization-location.success.message.organization_location_updated': 'Your location has been updated',
    'organization-location.success.message.organization_location_restored': 'Your location has been restored | All selected locations were restored',
    'organization-location.success.message.organization_location_deleted': 'Your location has been permanently deleted | All selected locations were permanently deleted',
    'organization-location.success.message.archived_organization_locations': 'Your location was moved to the archive | All selected locations were moved to the archive',

    'organization-location.error.message.archived_organization_locations': 'This location was already moved to the archive | These locations were already moved to the archive',
    'organization-location.error.message.organization_location_deleted': 'This location was already permanently deleted | These locations were already permanently deleted',
    'organization-location.error.message.organization_location_restored': 'This location was already restored | These locations were already restored',
    'organization-location.error.message.error_loading_page': 'Sorry, there was an error loading location.| Sorry, there was an error loading locations.',

    'organization-location.message.search.no_archived_organization_locations': "You don't have any archived locations.",
};
